/** A seeded `Math.random()` stand-in. */
export type Rng = () => number;

/**
 * mulberry32 — small, fast, and stable across engines, which is what makes
 * "same grid for the whole world" hold.
 */
export function mulberry32(a: number): Rng {
  return function () {
    a |= 0;
    a = (a + 0x6d2b79f5) | 0;
    let t = Math.imul(a ^ (a >>> 15), 1 | a);
    t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };
}

/** Integer in `[0, n)` drawn from `rnd`. */
export const randInt = (rnd: Rng, n: number): number => Math.floor(rnd() * n);
